// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TPutAnswerRequest, TPutAnswerModel, IMappers, TPutAnswerResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ICreateEditAnswerResponseV3Schema } from '../../entities/web_entities/CreateEditAnswerResponseV3Schema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createPutAnswerModel(parameters: TPutAnswerRequest): TPutAnswerModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'reviews',
    pathApi: '/v3/put-answer/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPutAnswerOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPutAnswerRequest;
}

export async function fetchPutAnswer<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPutAnswerOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPutAnswerResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPutAnswerModel(parameters),
    config,
  )) as FetchResponse<TPutAnswerResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateEditAnswerResponseV3Schema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPutAnswerResponse>;
}
